module.exports = __webpack_public_path__ + "img/qrcode.3678fd5a.jpg";